import { useState } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { NavTabs } from '@components/NavTabs';
import { useTranslation } from '@hooks';
import KnowledgeBase from './KnowledgeBase';
import Agents from './Agents';

const Container = styled('div')({
    '@media (max-width: 1024px)': {
        padding: 16,
    },
});

const PulseAI = () => {
    const { pathname } = useLocation();
    const [currentTab, setCurrentTab] = useState(pathname);
    const { t } = useTranslation();

    const availableTabs = [
        { label: t('Sidebar.agents'), value: '/messaging/pulse-ai/agents' },
        { label: t('Sidebar.knowledgeBase'), value: '/messaging/pulse-ai/knowledge-base' },
    ];

    const RouteMap = {
        '/messaging/pulse-ai/agents': 0,
        '/messaging/pulse-ai/knowledge-base': 1,
    };

    return (
        <Container>
            <NavTabs
                tabLinks={availableTabs}
                onTabClick={selectedTab => setCurrentTab(selectedTab)}
                currentTabIndex={RouteMap[currentTab]}
            />
            <Switch>
                <Route path="/messaging/pulse-ai/knowledge-base" component={KnowledgeBase} />
                <Route path="/messaging/pulse-ai/agents" component={Agents} />
                <Redirect from="/messaging/pulse-ai" to="/messaging/pulse-ai/agents" />
            </Switch>
        </Container>
    );
};

export default PulseAI;
